import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#ff5722',
    },
    background: {
      default: '#424a4a',
      paper: '#383838',
    },
    text: {
      primary: '#000',
    },
  },
});